import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { saveAs } from 'file-saver';

@Injectable({
    providedIn: 'root',
})
export class FileDownloadService {
    constructor(private http: HttpClient) {}

    /** Fetches the file as a blob and hands it to the browser's save-file
     *  flow. Cold observable — nothing happens until subscribed; fetch
     *  failures propagate to the caller's error handler. */
    downloadFile(url: string, filename: string): Observable<void> {
        return this.http.get(url, { responseType: 'blob' }).pipe(
            map((data: Blob): void => {
                saveAs(data, filename);
            }),
        );
    }
}
